import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import classnames from 'classnames';

import AdminPageContainer from '../common/AdminPageContainer';
import AdminPageTitle from '../common/AdminPageTitle';
import Loader from '../../common/loader/Loader';
import ErrorMessage from '../common/AdminErrorMessage';
import Input from '../common/DefaultInput';
import { SaveButton } from '../common/Buttons';

import useAdminEditWebinarPageState from './useAdminEditWebinarPageState';

const AdminEditWebinarPage = props => {
  const { id } = props.match.params;

  const { webinar, status, actions } = useAdminEditWebinarPageState(id, props.history);

  return (
    <AdminPageContainer>
      <AdminPageTitle to="/admin/webinars" title={`${id ? 'Edit' : 'New'} Webinar`} />

      <Loader isVisible={status.isLoading} />
      <ErrorMessage isVisible={status.isError && !status.isLoading} />

      <div className="mt-20px">
        <Input
          value={webinar.name.value}
          onChange={actions.changeName}
          label="Name"
          className={classnames({ 'is-invalid': !webinar.name.isValid })}
        />

        <div className="field">
          <label className="label">Description</label>
          <div className="control">
            <textarea
              className="textarea"
              placeholder="Webinar Description"
              value={webinar.description}
              onChange={actions.changeDescription}
            />
          </div>
        </div>

        <div className="field">
          <label className="label">Date</label>
          <div className="control">
            <DatePicker
              className="profile-input profile-input-sm"
              selected={webinar.date}
              onChange={actions.chnageDate}
              showYearDropdown
              showMonthDropdown
              dateFormat="dd.MM.yyyy"
            />
          </div>
        </div>

        <Input
          value={webinar.price.valueStr}
          onChange={actions.changePrice}
          label="Price"
          className={classnames({ 'is-invalid': !webinar.price.isValid })}
        />

        <SaveButton disabled={!status.canSave} onClick={actions.saveData} />
      </div>
    </AdminPageContainer>
  );
};

AdminEditWebinarPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }).isRequired,
  }).isRequired,
  history: PropTypes.object.isRequired,
};

export default AdminEditWebinarPage;
